import React from 'react';
import { Button, Card, Form } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { handleError } from '../../shared/functions/handleError';
import authSlice from '../../store/slices/auth.slice';
import i18n from '../../utils/localization/i18n';
import { AuthService } from './service';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

const schema = yup.object().shape({
  email: yup.string().email().required(),
  password: yup.string().required(),
});
const LoginPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = async (data: { email: string; password: string }) => {
    try {
      const response = await AuthService.login(data);
      localStorage.setItem('token', response.token);
      dispatch(
        authSlice.actions.setLoginState({
          isAuthenticated: true,
          userData: response?.userData,
        }),
      );
      await i18n.changeLanguage(response?.userData?.language);
      navigate('/admin/dashboard');
      toast.success(t('toast.loginSuccess'));
    } catch (error) {
      handleError(error);
    }
  };
  return (
    <div className="w-100 d-flex align-items-center justify-content-center vh-100 container">
      <Card className={'w-md-40'}>
        <Card.Body>
          <div className={'border-bottom pb-3 mb-3'}>
            <img src="/img/logo.svg" alt="Company logo" className={'w-100 '} />
          </div>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Form.Group className="mb-3" controlId="form.email">
              <Form.Label>{t('general.emailAddress')}</Form.Label>
              <Form.Control
                type="email"
                placeholder="name@example.com"
                isInvalid={!!errors.email}
                {...register('email')}
              />
              {errors?.email && (
                <Form.Control.Feedback type="invalid">
                  {errors.email?.message}
                </Form.Control.Feedback>
              )}
            </Form.Group>
            <Form.Group className="mb-3" controlId="form.password">
              <Form.Label>{t('general.password')}</Form.Label>
              <Form.Control
                type="password"
                placeholder="**********"
                isInvalid={!!errors.password}
                {...register('password')}
              />
              {errors?.password && (
                <Form.Control.Feedback type="invalid">
                  {errors.password?.message}
                </Form.Control.Feedback>
              )}
            </Form.Group>
            <Form.Group className="mb-3" controlId="form.password">
              <Button className={' w-100'} type={'submit'}>
                {t('button.signIn')}
              </Button>
            </Form.Group>
          </Form>
        </Card.Body>
      </Card>
    </div>
  );
};

export default LoginPage;
